export default "__VITE_ASSET__CRpLHFDl__"